export const COUNT_CITY_CARS = 'COUNT_CITY_CARS';
export const COUNT_OTHER_CARS = 'COUNT_OTHER_CARS';
export const LAST_PAGE = 'LAST_PAGE';
export const FILTER_CARS = 'FILTER_CARS';
export const FILTER_PARAMS = 'FILTER_PARAMS';
export const WAIT_FOR_REQUEST_FILTER_PARAMS = 'WAIT_FOR_REQUEST_FILTER_PARAMS';
export const SELECTED_DATA = 'SELECTED_DATA';
